import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style/Footer.css";

import { ReactComponent as Case } from "../assets/image/tabs/case.svg";
import { ReactComponent as Earn } from "../assets/image/tabs/earn.svg";
import { ReactComponent as Profile } from "../assets/image/tabs/profile.svg";

import { Trans } from "react-i18next";

export default function Footer() {
    const indicatorRef = useRef(null);
    const btnRefs = useRef([]);
    const footerRef = useRef(null);
    const location = useLocation();

    const tabs = [
        { path: "/", label: <Trans i18nKey="footer.cases" />, icon: Case},
        { path: "/earn", label: <Trans i18nKey="footer.earn" />, icon: Earn},
        { path: "/profile", label: <Trans i18nKey="footer.profile" />, icon: Profile},
    ];

    const activeIndex = tabs.findIndex((t) => t.path === location.pathname);

    const moveIndicator = (index) => {
        const indicator = indicatorRef.current;
        const footer = footerRef.current;
        const btn = btnRefs.current[index];

        if (!indicator || !footer || !btn) return;

        const btnRect = btn.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        const btnCenter = btnRect.left + btnRect.width / 2;
        let left = btnCenter - indicator.offsetWidth / 2 - footerRect.left;

        if (index === 0) {
            left -= 2;
        }

        indicator.style.left = `${left}px`;

        indicator.classList.add("active");
        setTimeout(() => indicator.classList.remove("active"), 300);
    };

    useEffect(() => {
        moveIndicator(activeIndex);
    }, [activeIndex]);

    

    return (
        <footer className="text-center mt-5" ref={footerRef}>
            <div className="active-footer-indicator" ref={indicatorRef} />

            {tabs.map((tab, i) => {
                const Icon = tab.icon;
                return (
                    <Link
                        key={i}
                        className={`footer-btn footer-btn-wrapper`}
                        ref={(el) => (btnRefs.current[i] = el)}
                        onClick={() => moveIndicator(i)}
                        to={tab.path}
                    >
                        <Icon
                            className={`footer-svg ${activeIndex === i ? "active" : ""}`}
                            width={24}
                            height={24}
                        />

                        <label className={`footer-text ${activeIndex === i ? "active" : ""}`}>
                            {tab.label}
                        </label>
                    </Link>
                );
            })}
        </footer>
    );
}
